import serverVars from 'server-vars';
import { isBot } from './botTypeHelpers';

export const getIsBotOnClient = (): boolean => {
    if (serverVars.get('enablers.newBotStandard')) {
        return isBot(serverVars.get('botType'));
    }
    return serverVars.get('btdtctd') === 'true';
};
